export default {
  QA: 'Q&A',
}
